import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";
import HomePage from "./HomePage";
import ProductPage from "./ProductPage";
import DemoPage from "./DemoPage";
import ChatsPage from "./ChatsPage";
import { UserProvider } from "./contexts/UserContext";

const KODLY_WIDGET_ORIGIN =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_KODLY_WIDGET_ORIGIN || "http://localhost:5173"
    : "REACT_APP_KODLY_WIDGET_ORIGIN_PLACEHOLDER";

const KODLY_WIDGET_TOKEN =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_KODLY_WIDGET_TOKEN
    : "REACT_APP_KODLY_WIDGET_TOKEN_PLACEHOLDER";

function KodlyWidgetIntegration() {
  useEffect(() => {
    if (!KODLY_WIDGET_TOKEN) {
      console.error("REACT_APP_KODLY_WIDGET_TOKEN is not configured");
      return;
    }

    if (document.getElementById("kodly-ai-agent-loader")) {
      return;
    }

    const script = document.createElement("script");
    script.id = "kodly-ai-agent-loader";
    script.src = `${KODLY_WIDGET_ORIGIN}/loader.js?token=${encodeURIComponent(KODLY_WIDGET_TOKEN)}`;
    script.async = true;
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return null;
}

// Kodly widget runs on tenant-simulation routes; /chats has its own
// Chatwoot embed for testing the native widget in isolation.
function ConditionalKodlyWidget() {
  const location = useLocation();
  if (location.pathname === "/chats") {
    return null;
  }
  return <KodlyWidgetIntegration />;
}

// Componente principal da aplicação
function AppContent() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DemoPage />} />
        <Route path="/produto/:slug" element={<ProductPage />} />
        <Route path="/demo" element={<HomePage />} />
        <Route path="/chats" element={<ChatsPage />} />
      </Routes>

      {/* Kodly widget embeds on tenant-simulation routes (skips /chats). */}
      <ConditionalKodlyWidget />
    </Router>
  );
}

function App() {
  return (
    <UserProvider>
      <AppContent />
    </UserProvider>
  );
}

export default App;
